// The point of this document is for development process
import constants from '@/constants';
import { getPageConfig } from '@/models/api/landingPageApi';
const { ADD_CART_AND_FAVORITES_STATUS, TABBAR_PAGE_APP_CODE } = constants;
const API_RESULT_CODE = {
  SUCCESS: 200,
  FAIL: 500
};

// Simulate native interaction methods for local development and use
export const nativeMethods = {
  call(name, data, callBack = () => {}) {
    try {
      this[`${name}`](name, data, callBack);
    } catch (err) {
      console.error(
        `Natively compatible with native methods ${name} This method is not available`,
        err
      );
    }
  },
  // Add shopping cart
  addShoppingCartList(name, data, callBack) {
    const cartList = JSON.parse(sessionStorage.getItem('cartList')) || {
      list: []
    };
    if (cartList.list.length >= 20) {
      callBack({ result: ADD_CART_AND_FAVORITES_STATUS.EXCEED_MAX_LIMIT });
      return;
    }
    const existenceOrNot =
      (cartList.list.length &&
        cartList.list.some(
          cur => cur.productItem.asin === data.item.productItem.asin
        )) ||
      false;
    if (!existenceOrNot) {
      cartList.list.push(data.item);
      sessionStorage.setItem('cartList', JSON.stringify(cartList));
    }
    callBack(data);
  },
  // Get shopping cart data
  getShoppingCartList(name, data, callBack) {
    const cartList = JSON.parse(sessionStorage.getItem('cartList')) || {
      list: []
    };
    callBack(cartList);
  },
  // Deletes shopping cart specified data
  deleteShoppingCartList(name, data, callBack) {
    const cartList = JSON.parse(sessionStorage.getItem('cartList')) || {
      list: []
    };
    if (cartList.list.length > 0) {
      cartList.list = cartList.list.filter(
        item => !data.asins.some(itemx => itemx === item.productItem.asin)
      );
      sessionStorage.setItem('cartList', JSON.stringify(cartList));
    }
    callBack(cartList);
  },
  // Update shopping cart number
  updateShoppingCartCount(name, data) {
    const cartList = JSON.parse(sessionStorage.getItem('cartList')) || {
      list: []
    };
    if (cartList.list.length > 0) {
      cartList.list.forEach(item => {
        if (item.productItem.asin === data.asin) {
          item.count = data.count;
        }
      });
      sessionStorage.setItem('cartList', JSON.stringify(cartList));
    }
  },
  // Get the number of cart items
  getShoppingCartListLength(name, data, callBack) {
    const cartList = JSON.parse(sessionStorage.getItem('cartList')) || {
      list: []
    };
    callBack(cartList.list.length);
  },
  // Get the deviceId
  getDeviceId(name, data, callBack) {
    callBack({ deviceId: '' });
  },
  // Update shopping cart data Check status
  updateShoppingCartItemSelect(name, data) {
    const cartList = JSON.parse(sessionStorage.getItem('cartList')) || {
      list: []
    };
    if (cartList.list.length > 0) {
      cartList.list.forEach(item => {
        if (item.productItem.asin === data.asin) {
          item.selected = data.select;
        }
      });
      sessionStorage.setItem('cartList', JSON.stringify(cartList));
    }
  },
  // Delete all items in your cart
  deleteAllShoppingCartItems() {
    sessionStorage.setItem('cartList', { list: [] });
  },
  // Add to Favorites
  addFavoriteList(name, data, callBack) {
    const favoritesList = JSON.parse(
      sessionStorage.getItem('favoritesList')
    ) || { list: [] };
    if (favoritesList.list.length >= 20) {
      callBack({ result: ADD_CART_AND_FAVORITES_STATUS.EXCEED_MAX_LIMIT });
      return;
    }
    const existenceOrNot =
      (favoritesList.list.length &&
        favoritesList.list.some(
          cur => cur.productItem.asin === data.item.productItem.asin
        )) ||
      false;
    if (!existenceOrNot) {
      favoritesList.list.push(data.item);
      sessionStorage.setItem('favoritesList', JSON.stringify(favoritesList));
    }
    callBack({ result: ADD_CART_AND_FAVORITES_STATUS.SUCCESSFUL });
  },
  // Determine whether to display favorites based on asin
  isAddToFavorite(name, data, callBack) {
    const favoritesList = JSON.parse(
      sessionStorage.getItem('favoritesList')
    ) || { list: [] };
    const result = favoritesList.list.some(
      item => item.productItem.asin === data.asin
    );
    callBack({ result });
  },
  // Delete a specified item from your favorites
  deleteFavoriteItems(name, data, callBack) {
    const favoritesList = JSON.parse(
      sessionStorage.getItem('favoritesList')
    ) || { list: [] };
    if (favoritesList.list.length > 0) {
      favoritesList.list = favoritesList.list.filter(
        item => !data.asins.some(itemx => itemx === item.productItem.asin)
      );
      sessionStorage.setItem('favoritesList', JSON.stringify(favoritesList));
    }
    callBack();
  },
  // Favorites on top
  favoriteSort(name, data, callBack) {
    const favoritesList = JSON.parse(
      sessionStorage.getItem('favoritesList')
    ) || { list: [] };
    if (favoritesList.list.length > 0) {
      const index = favoritesList.list.findIndex(
        item => item.productItem.asin === data.asin
      );
      const arr = favoritesList.list.filter(
        item => item.productItem.asin !== data.asin
      );
      arr.unshift(favoritesList.list[index]);
      favoritesList.list = arr;
      sessionStorage.setItem('favoritesList', JSON.stringify(favoritesList));
    }
    callBack();
  },
  // Get favorites data
  getAllFavoriteItemList(name, data, callBack) {
    const favoritesList = JSON.parse(
      sessionStorage.getItem('favoritesList')
    ) || { list: [] };
    callBack(favoritesList);
  },
  openNativePage(name, data, callBack) {
    location.href = data.url;
    callBack({});
  },
  getWebViewOriginalPagePath(name, data, callBack) {
    callBack({ path: 'path' });
  },
  // Simulate APP memory storage
  saveDataToMemoryCache(name, data, callBack = () => null) {
    const list = JSON.parse(sessionStorage.getItem('saveDataSession')) || [];
    if (list.length) {
      const existenceOrNot = list.some(item => {
        if (item.key === data.key) {
          item.value = data.value;
        }
        return item.key === data.key;
      });
      if (!existenceOrNot) {
        list.push(data);
      }
    } else {
      list.push(data);
    }
    sessionStorage.setItem('saveDataSession', JSON.stringify(list));
    callBack();
  },
  // Read data stored in APP memory
  getDataFromMemoryCache(name, data, callBack) {
    const list = JSON.parse(sessionStorage.getItem('saveDataSession')) || [];
    if (list.length) {
      const existenceOrNot = list.some(item => {
        if (item.key === data.key) {
          callBack(item);
        }
        return item.key === data.key;
      });
      if (!existenceOrNot) {
        callBack({});
      }
    }
  },
  deleteDataFromMemoryCache(name, data, callBack) {
    const list = JSON.parse(sessionStorage.getItem('saveDataSession')) || [];
    if (list.length) {
      const remainedList = list.filter(item => {
        return item.key !== data.key;
      });
      sessionStorage.setItem('saveDataSession', JSON.stringify(remainedList));
      callBack({});
    }
  },
  // Simulate application disk storage
  saveDataToDiskCache(name, data, callBack = () => null) {
    const list = JSON.parse(localStorage.getItem('saveDataLocalStorage')) || [];
    if (list.length) {
      const existenceOrNot = list.some(item => {
        if (item.key === data.key) {
          item.value = data.value;
        }
        return item.key === data.key;
      });
      if (!existenceOrNot) {
        list.push(data);
      }
    } else {
      list.push(data);
    }
    localStorage.setItem('saveDataLocalStorage', JSON.stringify(list));
    callBack();
  },
  // Read the application disk storage
  getDataFromDiskCache(name, data, callBack) {
    const list = JSON.parse(localStorage.getItem('saveDataLocalStorage')) || [];
    if (list.length) {
      const existenceOrNot = list.some(item => {
        if (item.key === data.key) {
          callBack(item.value);
        }
        return item.key === data.key;
      });
      if (!existenceOrNot) {
        callBack({});
      }
    }
  },
  changeTabbarSelectItem(name, data, callBack) {
    callBack();
  },
  isAuthenticated(name, data, callBack) {
    callBack({ result: true });
  },
  getAppCurrentMode(name, data, callBack) {
    callBack({ appMode: 'NORMAL_MODE' });
  },
  startLogin(name, data, callBack) {
    callBack();
  },
  controlWebViewBounces(name, data, callBack) {
    callBack();
  },
  getAccessToken(name, data, callBack) {
    const accessToken = sessionStorage.getItem('token') ?? '';
    callBack({ accessToken });
  },
  onOpenUrlProvidedByNative(name, data, callBack) {
    callBack({ url: 'path' });
  },
  onGatewayElementMounted(name, data, callBack) {
    callBack();
  },
  async getAppConfig(name, data, callBack) {
    try {
      const result = await getPageConfig();
      if (result.data.code === API_RESULT_CODE.SUCCESS) {
        callBack(result.data.data);
      } else {
        callBack({});
      }
    } catch (error) {
      callBack({});
      console.error('get config page error>>>', error);
    }
  },
  getAppTabbarHeight(name, data, callBack) {
    callBack({ height: 0 });
  },
  onAccessTokenInvalid(name, data, callBack) {
    callBack({});
  }
};
